export default "__VITE_ASSET__bcac5872__"